import * as types from 'constants/ActionTypes';
import { indexByProp } from 'utils/global';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const fetchDealersFailureReducer = () => initialState;

/**
 * @param {Object<string, string>} state
 * @param {import('modules/dealers/types').GenericDealersActionPage} action
 * @returns {Object<string, string>}
 */
const fetchDealersSuccessReducer = (_, { payload }) => indexByProp('rel', payload.links);

export default createReducer(initialState, {
  [types.FETCH_DEALERS_FAILURE]: fetchDealersFailureReducer,
  [types.FETCH_DEALERS_SUCCESS]: fetchDealersSuccessReducer,
});
